<!-- ===============================================-->
<!--    Main Content-->
<!-- ===============================================-->
<main class="main" id="top">
  <div class="container" data-layout="container">
    <nav
      app-navbar-horizontal
      class="navbar navbar-light navbar-horizontal navbar-expand-lg"
    ></nav>

    <app-breadcrumb></app-breadcrumb>
    <div class="content">
      <router-outlet></router-outlet>
    </div>
  </div>
</main>
<!-- ===============================================-->
<!--    End of Main Content-->
<!-- ===============================================-->
